<template>
    <div class="MaintainContent">
        <div class="content_maintain">
            <div class="notify_number">
                <h4>通報單號：{{notify_number}}</h4>
            </div>
            <div class="create_input">
                <div class="name_style house_number">
                    <div>通報戶號:</div>
                    <input type="text" class="form-control" v-model.trim="house_number" placeholder="通報戶號" disabled>
                </div>
                <div class="name_style notify_name">
                    <div>通報人名:</div>
                    <input type="text" class="form-control" v-model.trim="notify_name" placeholder="通報人" disabled>
                </div>
            </div>
            <div class="create_input">
                <div class="name_style contact_number">
                    <div>連絡電話:</div>
                    <input type="text" class="form-control" v-model.trim="contact_number" placeholder="連絡電話" disabled>
                </div>
                <div class="name_style notify_time">
                    <div>通報時間:</div>
                    <input type="text" class="form-control" v-model.trim="notify_time" placeholder="通報時間" disabled>
                </div>
            </div>
            <div class="create_input">
                <div class="notify_time">
                    <div>通報內容:</div>
                    <textarea rows="4" cols="50" v-model.trim="notify_content" placeholder="通報內容..." disabled></textarea>
                </div>
            </div>
            
            <!-- 損壞照片 -->
            <div class="upimg_content">
                <div class="upimg_title">
                    <p>損壞照片</p>
                </div>
                <div class="img_content">
                    <div class="show_img mb-1" style="margin-right: 10px" v-for="item, idx in img_before" :key="idx">
                        <img class="show_this_img" @click="modal_block(item)" :src="item">
                    </div>
                </div>
            </div>
            <!-- 維修後 -->
            <div v-show="maintain_status == 5">
                <div class="create_input" style="margin-top:20px;">
                    <div class="name_style notify_time">
                        <div>維修項目:</div>
                        <input type="text" class="form-control" v-model.trim="maintain_type" placeholder="維修項目" disabled>
                    </div>
                </div>
                <div class="create_input">
                    <div class="notify_time">
                        <div>維修內容:</div>
                        <textarea rows="4" cols="50" v-model.trim="maintain_content" placeholder="維修內容..." disabled></textarea>
                    </div>
                </div>
                <div class="upimg_content">
                    <div class="upimg_title">
                        <p>維修後照片</p>
                    </div>
                    <div class="img_content">
                        <div class="show_img mb-1" style="margin-right: 10px" v-for="item, idx in images_later" :key="idx">
                            <img class="show_this_img" @click="modal_block(item)" :src="item">
                        </div>
                    </div>
                </div>
            </div>

            
            <!-- <div class="create_input">
                <div class="notify_time" v-if="feedback_onoff == false">
                    <div>滿意度調查:</div>
                    <textarea rows="4" cols="50" v-model.trim="tenant_feedback" placeholder="請輸入您的寶貴意見..."></textarea>
                </div>
                <div class="notify_time" v-else>
                    <div>滿意度調查:</div>
                    <textarea rows="4" cols="50" v-model.trim="tenant_feedback" disabled></textarea>
                </div>
            </div>
            <div class="submit_btn" v-show="feedback_onoff == false">
                <button class="btn btn-primary" @click="this_submit">
                    送出
                </button>
            </div> -->
            <div class="create_btn">
                <button class="btn btn-secondary" @click="this_cancel">
                    返回
                </button>
            </div>
        </div>

        <div class="my_model" v-show="model_switch" @click="model_switch = !model_switch">
            <div class="my_model_content">
                <img class="model_img" :src="modal_img">
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/css/member/maintain/maintainContent.css";

export default {
    name: "MaintainContent",
    data () {
        return {
            notify_number: null, //通報單號
            house_number: null, //通報戶號
            notify_name: null, //通報人
            contact_number: null, //連絡電話
            notify_time: null, //通報時間
            notify_content: null, //通報內容
            //
            maintain_status: null, //維修單狀態
            maintain_type: null, //維修項目
            maintain_content: null, //維修內容
            tenant_feedback: null, //租戶意見
            feedback_onoff: null, //show
            //
            img_before: [], //損壞照片
            images_later: [], //維修後
            // modal
            model_switch: false,
            modal_img: '',
        }
	},
    beforeMount: function () {
        if (this.$route.name == 'MemberHome' && !localStorage.getItem('house_number') && this.$store.state.house_number == null) {
            this.$router.push({ name: 'Login' });
        } else {
            const getData = new FormData();
            getData.append('CMD', 'FrontMemberHomeMaintainContent');
            if (localStorage.getItem('house_number') != null) {
                getData.append('house_number', localStorage.getItem('house_number'));
            }
            getData.append('id', this.$route.params.id);
            getData.append('type', 'getData');
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
            .then(response => {
                // console.log(response);
                const get_data = response.data.maintain_data;
                this.notify_number = get_data.notify_number;
                this.house_number = get_data.house_number;
                this.notify_name = get_data.notify_name;
                this.contact_number = get_data.contact_number;
                this.notify_time = get_data.notify_time;
                this.notify_content = get_data.notify_content;
                //
                this.maintain_type = get_data.maintain_type;
                this.maintain_status = get_data.maintain_status;
                this.maintain_content = get_data.maintain_content;
                if (get_data.tenant_feedback == '') {
                    this.feedback_onoff = false
                } else {
                    this.tenant_feedback = get_data.tenant_feedback;
                }
                //
                if (get_data.images_before != 'false') {
                    const img_before = get_data.images_before;
                    this.img_before = JSON.parse(img_before);
                }
                if (get_data.images_later != 'false') {
                    const img_later = get_data.images_later;
                    this.images_later = JSON.parse(img_later);
                }
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    methods: {
        this_cancel () {
            this.$router.push({ name: 'MaintainList'});
        },
        // this_submit () {
        //     if (this.tenant_feedback == null) {
        //         alert('請輸入相關資訊');
        //     } else {
        //         var yes_submit = confirm('確定送出？');
        //         if (yes_submit) {
        //             const upData = new FormData();
        //             upData.append('CMD', 'FrontMemberHomeMaintainContent');
        //             upData.append('type', 'upData');
        //             upData.append('house_number', localStorage.getItem('house_number'));
        //             upData.append('id', this.$route.params.id);
        //             upData.append('tenant_feedback', this.tenant_feedback);
        //             this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, upData)
        //             .then(response => {
        //                 // console.log(response);
        //                 if (response.data.result == true) {
        //                     alert('送出成功');
        //                     this.$router.push({ name: 'MaintainList'});
        //                 } else {
        //                     alert(response.data.msg);
        //                     console.log(response.data.error);
        //                 }
        //             })
        //             .catch(error => {
        //                 console.log(error);
        //             })
        //         }
        //     }
        // },
        modal_block (toImagSrc) {
            this.modal_img = toImagSrc;
            this.model_switch = true;
        }
    }
}
</script>

<style>
    
</style>